// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Polls/index.css
// module id = 2349
// module chunks = 0